import React from 'react';
import styles from "./Tab.module.css";

const TabHolder = ({ children }) => (
    <div className={styles.tabHolder}>
        {children}
    </div>
);

export default TabHolder;